import type { RaceId } from '@ps/isp-web-services-types';

export const getRaceTimeFromRaceId = (raceId: RaceId) => {
  const [, raceTime] = raceId.split('.');

  return raceTime;
};
